export default "__VITE_ASSET__DonjtHkD__"